import {QueueItemType} from "../../types";
import {ImageCenterBox} from "../../components/ImageCenter";
import {useEffect, useRef} from "react";

export interface QueueItemVideoProps {
    data: QueueItemType;
    index: number;
}

export default function QueueItemVideo({data, index}: QueueItemVideoProps) {
    const ref = useRef<any>(null);

    useEffect(() => {
        if (!ref?.current) return;

        if (index === 0) {
            ref.current.play();
        }
    }, []);

    return (
        <ImageCenterBox className="!bg-dark-black rounded-none">
            <video ref={ref} muted={true} autoPlay={index === 0} loop={true} controls={true} src={`${data.metadata.src}#t=0.1`} className="flex-1 min-h-[20px] bg-dark-black max-w-full mx-auto max-h-[600px]"/>
        </ImageCenterBox>
    );
}
